import axios from 'axios';

const API_BASE =
  process.env.REACT_APP_API_BASE ||
  (['localhost', '127.0.0.1'].includes(window.location.hostname)
    ? 'http://localhost:3001'
    : '');

export async function fetchAteSwVersions() {
  const response = await axios.get(`${API_BASE}/api/ate-sw-versions`);
  return response.data;
}

export async function fetchDistinctSerialNumbers() {
  const response = await axios.get(`${API_BASE}/api/distinct-serial-numbers`);
  return (response.data || [])
    .map((value) => String(value || '').trim())
    .filter(Boolean)
    .map((value) => ({ value, label: value }));
}

export async function fetchGlobalMetadataRecords(filters) {
  const response = await axios.get(`${API_BASE}/api/global_metadata`, {
    params: {
      fileName: filters.fileNameFilter || null,
      serialNumbers: Array.isArray(filters.selectedSerialNumbers) && filters.selectedSerialNumbers.length
        ? filters.selectedSerialNumbers.map((serialNumber) => serialNumber.value).join(',')
        : null,
      startDate: filters.startDate ? filters.startDate.toISOString().split('T')[0] : null,
      endDate: filters.endDate ? filters.endDate.toISOString().split('T')[0] : null,
      ateSwVersion: filters.ateSwVersion || null,
      uutStatus: filters.uutStatus || null,
    },
  });
  return response.data;
}

export async function fetchTestSteps(fileId) {
  const response = await axios.get(`${API_BASE}/api/test_steps`, { params: { fileId } });
  return response.data;
}

export async function fetchDatabaseRows(filters, page = 1, limit = 100) {
  const response = await axios.get(`${API_BASE}/api/database-rows`, {
    params: {
      fileName: filters.fileNameFilter || null,
      serialNumbers: Array.isArray(filters.selectedSerialNumbers) && filters.selectedSerialNumbers.length
        ? filters.selectedSerialNumbers.map((serialNumber) => serialNumber.value).join(',')
        : null,
      startDate: filters.startDate ? filters.startDate.toISOString().split('T')[0] : null,
      endDate: filters.endDate ? filters.endDate.toISOString().split('T')[0] : null,
      ateSwVersion: filters.ateSwVersion || null,
      uutStatus: filters.uutStatus || null,
      stepNumber: filters.stepNumberFilter || null,
      page,
      limit,
    },
  });
  return response.data;
}

export async function deleteGlobalMetadataRecord(id) {
  await axios.delete(`${API_BASE}/api/global_metadata/${id}`);
}

export async function deleteSelectedGlobalMetadataRecords(ids) {
  await axios.delete(`${API_BASE}/api/global_metadata`, {
    data: { ids },
  });
}

export async function deleteAllGlobalMetadataRecords() {
  await axios.delete(`${API_BASE}/api/global_metadata/all`);
}
